import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EditorComponentBase, InputFormatterDirective } from 'ngx-lib';
import { ValidationErrorMessageComponent } from '../../validation-error-message/validation-error-message.component';

@Component({
    selector: 'app-currency-editor',
    templateUrl: './currency-editor.component.html',
    styleUrls: ['./currency-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, FormsModule, InputFormatterDirective, ValidationErrorMessageComponent]
})
export class CurrencyEditorComponent extends EditorComponentBase<number | null> {
    constructor() {
        super();
    }

    dataChanged(event: string) {
        this.bindingProperty = this.bindingProperty ? parseFloat(event) : null;
        this.valueChange.emit();
        this.validate();
    }
}
